import { Component, OnInit, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

type inputType = 'text' | 'number';

@Component({
  selector: 'kt-text-input',
  templateUrl: './text-input.component.html',
  styleUrls: ['./text-input.component.scss']
})
export class TextInputComponent implements OnInit {
  @Input() formGroup: FormGroup;
  @Input() controlName: string;
  @Input() maxLength = 200;
  @Input() minLength = 0;
  @Input() showMaxLength = true;
  @Input() placeholder: string = '';
  @Input() type: inputType = 'text';
  @Input() mask: string = null;

  constructor() { }

  ngOnInit() {
  }

}
